export default {
    ADD_REPORT_DATA: "setSimplePreview",
    ADD_ACT_SCORE: "setActScore"
}
